document.addEventListener("DOMContentLoaded", async () => {
  const jsonEl = document.getElementById("ProductMetafieldsJSON");
  if (!jsonEl) return;

  let payload;
  try {
    payload = JSON.parse(jsonEl.textContent);
  } catch (err) {
    console.error("Failed to parse metafield JSON:", err);
    return;
  }

  const wrapper = document.querySelector('.accordion__content.rte');
  if (!wrapper) return;

  const list = document.createElement("ul");
  list.className = "product-meta";

  const metafields = payload.metafields || {};
  const gidQueue = [];

  for (const [key, mf] of Object.entries(metafields)) {
    const raw = mf?.value ?? mf;
    if (!raw) continue;

    const value = Array.isArray(raw) ? raw : [raw];
    const gids = value.filter(
      (v) => typeof v === "string" && v.startsWith("gid://shopify/Metaobject/")
    );

    if (gids.length > 0) {
      gidQueue.push({ key, gids });
    } else {
      const label = key
        .replace(/[_-]/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());
      const val = value.join(", ");
      const li = document.createElement("li");
      li.innerHTML = `<strong>${label}:</strong> <span>${val}</span>`;
      list.appendChild(li);
    }
  }

  if (gidQueue.length > 0) {
    const labels = await fetchMetaobjectLabels(
      gidQueue.flatMap((entry) => entry.gids)
    );
    for (const { key, gids } of gidQueue) {
      const readableValues = gids.map((gid) => labels[gid] || gid);
      const label = key
        .replace(/[_-]/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());
      const li = document.createElement("li");
      li.innerHTML = `<strong>${label}:</strong> <span>${readableValues.join(
        ", "
      )}</span>`;
      list.appendChild(li);
    }
  }

  if (list.children.length) {
    const heading = document.createElement("h3");
    heading.textContent = "PRODUCT DETAILS";
    wrapper.appendChild(heading);
    wrapper.appendChild(list);
  }
});

// Replace with your Storefront API token
const STOREFRONT_API_TOKEN = "0e85cdadce0dfda99d1f20273e5fc9d4";

async function fetchMetaobjectLabels(gids) {
  const query = `
      query getMetaobjects($ids: [ID!]!) {
          nodes(ids: $ids) {
              ... on Metaobject {
                  id
                  handle
                  type
                  fields {
                      key
                      value
                  }
              }
          }
      }
  `;

  const res = await fetch(
    "https://thesportinglodge.myshopify.com/api/2023-10/graphql.json",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": STOREFRONT_API_TOKEN,
      },
      body: JSON.stringify({ query, variables: { ids: gids } }),
    }
  );

  const json = await res.json();
  const output = {};
  for (const node of json?.data?.nodes || []) {
    if (node && node.id && Array.isArray(node.fields)) {
      const nameField = node.fields.find((f) =>
        ["label", "title", "name"].includes(f.key)
      );
      output[node.id] = nameField?.value || node.handle || node.type || node.id;
    }
  }
  return output;
}
